// Display-only split of the shared `brokers` collection into two sidebar views.
// No data model change — brokers are filtered client-side by their existing
// `broker_type_label`. ICP = "Institutional Channel Partner"; Retail = everything
// else (the 3 legacy types + any edge-case/blank type as a catch-all per spec §3).
export const ICP_TYPE_LABEL = "Institutional Channel Partner";

// Relationship statuses that move a broker out of the active directory into Archived.
export const ARCHIVED_BROKER_STATUSES = ["Inactive", "Blacklisted"];
export const isArchivedBroker = (statusLabel) => ARCHIVED_BROKER_STATUSES.includes(statusLabel);

export const BROKER_SCOPES = {
  retail: {
    key: "retail",
    navLabel: "Retail Brokers",
    title: "Retail Brokers",
    eyebrow: "Network · Retail",
    subtitle: "Sourcing, buyer-side and dual-role channel partners.",
    // A broker belongs to Retail when its type is NOT the ICP type (catch-all).
    match: (label) => label !== ICP_TYPE_LABEL,
    defaultTypeLabel: "Buyer-side Channel Partner",
    path: "/brokers/retail",
  },
  icp: {
    key: "icp",
    navLabel: "ICP Brokers",
    title: "ICP Brokers",
    eyebrow: "Network · Institutional",
    subtitle: "Institutional Channel Partners.",
    match: (label) => label === ICP_TYPE_LABEL,
    defaultTypeLabel: ICP_TYPE_LABEL,
    path: "/brokers/icp",
  },
  archived: {
    key: "archived",
    navLabel: "Archived Brokers",
    title: "Archived Brokers",
    eyebrow: "Network · Archived",
    subtitle: "Inactive and blacklisted brokers. Reactivate by changing their status back to Active.",
    match: () => true, // type-agnostic; membership is by archived status (handled in the list)
    defaultTypeLabel: null,
    path: "/brokers/archived",
  },
};
